import Vue from "vue";
const vm = new Vue()

export const getLineBookingByBookingNo = async (booking_no) => {
    return new Promise((resolve, reject) => {
      vm.$http
        .get(vm.$API_URL + "/scan/booking", {
            headers: {
                Token: localStorage.getItem("access_token"),
            },
            params: {
                booking_no: booking_no,
            },
        })
        .then((res) => {
            if (!res.data.status) {  
                if(res.data.error.code === "ERROR_BOOKING_NOTFOUND"){
                    reject("ขออภัย! เลข Booking ID ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง");
                }
            }

            resolve(res.data.data)
            
        }).catch((error) => {
            if (error.response) {
                if (error.response.status == 500) {
                    reject(error.response.data);
                }
            }
            reject(error);
        });
    })
}